export default {
    patientHealthData : "",
};
